export default class Page {
    constructor() {        
    }

    /**
     * @param {string} elementId
     * @returns {HTMLElement}
     */
    static getElement(elementId) {
        return document.getElementById(elementId);
    }

    /**
     * @param {string} text
     * @returns {Text}
     */
    static createTextElement(text) {
        return document.createTextNode(text);
    }

    /**
     * @param {string} elementId
     * @param {string} text
     */
    static setInnerHtml(elementId, text) {
        var element = Page.getElement(elementId);
        if (element) {
            element.innerHTML = text;
        }
    }

    /**
     * @param {string} tagName
     * @param {HTMLElement} parent
     * @param {string} id
     * @param {string} className
     * @returns {HTMLElement}
     */
    static createElement(tagName, parent, id, className) {
        var element = document.createElement(tagName);
    
        if (className) {
            element.className = className;
        }
        if (id) {
            element.id = id;
        }
    
        if (parent) {
            parent.appendChild(element);
        }
    
        return element;
    }

    /**
     * @param {string} inputType
     * @param {HTMLElement} parent
     * @param {string} id
     * @param {string} className
     * @returns {HTMLInputElement}
     */
    static createInputElement(inputType, parent, id, className) {
        var element = document.createElement('input');
        element.type = inputType;

        if (className) {
            element.className = className;
        }
        if (id) {
            element.id = id;
        }
    
        if (parent) {
            parent.appendChild(element);
        }
    
        return element;
    }

    /**
     * @param {string} elementId
     */
    static clearChildren(elementId) {
        var element = Page.getElement(elementId);
        if (element) {
            while (element.firstChild) {
                element.removeChild(element.firstChild);
            }
        }
    }

    /**
     * @param {string} parentId
     * @param {string} elementId
     */
    static removeElementById(parentId, elementId) {
        this.removeElement(parentId, Page.getElement(elementId));
    }

    /**
     * @param {string} parentId
     * @param {HTMLElement} element
     */
    static removeElement(parentId, element) {
        var parent = Page.getElement(parentId);

        if (!parent || !element) {
            return;
        }

        /////parent.removeChild(element);

        try {
            parent.removeChild(element);
        } catch (e) {
            if (e instanceof DOMException) {
                console.error("Caught a DOMException. parentId=" + parentId + ' elementId=' + element.id, e.name, e.message);

                // Specific handling based on the DOMException name, e.g., NotAllowedError, SecurityError
                if (e.name === "SyntaxError") {
                    console.warn("Invalid CSS selector used.");
                }
            } 
            else {
                // Handle other types of errors
                console.error("Caught a non-DOMException error.  parentId=" + parentId + ' elementId=' + element.id, e);
            }
        }
    }

    /**
     * @param {HTMLElement} element
     */
    static hideElement(element) {
        if (element) {
            element.style.display = 'none';
        }
    }

    /**
     * @param {HTMLElement} element
     */
    static showElement(element) {
        this.showElementWithValue(element, 'block');
    }

    /**
     * @param {string} elementId 
     * @param {string} visibleDisplayValue 
     */
    static showElementIdWithValue(elementId, visibleDisplayValue) {
        Page.showElementWithValue(Page.getElement(elementId), visibleDisplayValue);
    }

    /**
     * @param {HTMLElement} element
     * @param {string} visibleDisplayValue
     */
    static showElementWithValue(element, visibleDisplayValue) {
        if (element) {
            element.style.display = visibleDisplayValue;
        }
    }

    /**
     * @param {string} elementId
     */
    static hideElementId(elementId) {
        Page.hideElement(Page.getElement(elementId));
    }

    /**
     * @param {string} elementId
     */
    static showElementId(elementId) {
        Page.showElement(Page.getElement(elementId));
    }
}